//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  CardNumber,
  CardExpiry,
  CardCvc,
  createToken
} from "vue-stripe-elements-plus";
import { StripePaymentService } from "@nuskin/ns-shop";
import { NsToast } from "@nuskin/design-components";
import { Money } from "v-money";

export default {
  name: "NsStripeDonationForm",
  components: {
    CardNumber,
    CardExpiry,
    CardCvc,
    Money,
    NsToast
  },
  props: {
    /**
     * The site key for reCaptcha
     */
    captchaKey: {
      type: String,
      default: ""
    },
    /**
     * The account key for stripe
     */
    stripeKey: {
      type: String,
      default: ""
    },
    /**
     * Translated label
     */
    submitLabel: {
      type: String,
      default: "Donate"
    },
    /**
     * Translated success message
     */
    continueAlipayLabel: {
      type: String,
      default: "Continue with Alipay"
    },
    /**
     * Translated label
     */
    personalInfoTitle: {
      type: String,
      default: "Personal Information"
    },
    /**
     * Translated label
     */
    nuskinIdLabel: {
      type: String,
      default: "Nu Skin ID"
    },
    /**
     * Translated label
     */
    optionalLabel: {
      type: String,
      default: "optional"
    },
    /**
     * Translated label
     */
    firstNameLabel: {
      type: String,
      default: "First Name"
    },
    /**
     * Translated label
     */
    lastNameLabel: {
      type: String,
      default: "Last Name"
    },
    /**
     * Translated label
     */
    amountTitle: {
      type: String,
      default: "How much would you like to donate?"
    },
    /**
     * Translated label
     */
    amountLabel: {
      type: String,
      default: "Custom Amount"
    },
    /**
     * Translated label
     */
    amounts: {
      type: String,
      default: JSON.stringify([
        {
          value: 25,
          displayText: "$25"
        },
        {
          value: 50,
          displayText: "$50"
        }
      ])
    },
    /**
     * Translated label
     */
    donateTitle: {
      type: String,
      default: "Donate with Card"
    },
    /**
     * Translated label
     */
    paymentMethodTitle: {
      type: String,
      default: "Select Payment Method"
    },
    /**
     * Translated label
     */
    cardLabel: {
      type: String,
      default: "Credit Card"
    },
    /**
     * Translated label
     */
    alipayLabel: {
      type: String,
      default: "Alipay"
    },
    /**
     * Translated label
     */
    alipayRedirectNotice: {
      type: String,
      default:
        "You will be redirected to the Alipay site to complete your payment."
    },

    /**
     * Translated label
     */
    emailLabel: {
      type: String,
      default: "Email Address"
    },
    /**
     * Translated label
     */
    emailErrorMessage: {
      type: String,
      default: "Please use a valid email"
    },
    /**
     * Translated label
     */
    cardNumberLabel: {
      type: String,
      default: "Card Number"
    },
    /**
     * Translated label
     */
    expiryLabel: {
      type: String,
      default: "Expiration Date"
    },
    /**
     * Translated label
     */
    cvcLabel: {
      type: String,
      default: "Security Code"
    },
    /**
     * Translated error message for a minimum amount
     */
    minDonationAmountLabel: {
      type: String,
      default: "Donation amount must be at least $1.00"
    },
    /**
     * Url that will redirect upon a successful donation reponse
     */
    thankYouUrl: {
      type: String,
      default: ""
    },
    /**
     * Translated success message
     */
    processingText: {
      type: String,
      default: "Processing"
    },
    /**
     * Translated success message
     */
    checkingAlipayText: {
      type: String,
      default: "Checking Alipay for payment confirmation."
    },
    /**
     * Translated success message
     */
    successMessage: {
      type: String,
      default: "Your payment was successful!"
    },
    /**
     * Translated failed message
     */
    errorMessage: {
      type: String,
      default: "Something went wrong with your payment."
    }
  },
  data() {
    return {
      /**
       * Money options
       */
      money: {
        decimal: ".",
        thousands: ",",
        precision: 2,
        masked: false
      },
      /**
       * Amount of the donation
       */
      amount: 0,
      /**
       * Button amount of the donation
       */
      buttonAmount: null,
      /**
       * Custom amount of the donation
       */
      customAmount: 0,
      /**
       * Email address from the donar
       */
      email: "",
      /**
       * Donars first name
       */
      firstName: "",
      /**
       * Donars last name
       */
      lastName: "",
      /**
       * Donars distriburtor ID
       */
      affiliateId: "",
      /**
       * Payment method
       */
      paymentMethod: "card",
      /**
       * Donars credit card number info {complete, error, etc}
       */
      numberInfo: {},
      /**
       * Donars credit card experation date info {complete, error, etc}
       */
      expiryInfo: {},
      /**
       * Donars CVC from credit card info {complete, error, etc}
       */
      cvcInfo: {},
      /**
       * Variable to set state if all required fields are filled out
       */
      complete: false,
      /**
       * Loading state when processing payment
       */
      loading: false,
      /**
       * Stripe element id if focused
       */
      stripeFocusId: "",
      /**
       * After form submit show errors if any
       */
      showErrors: "",
      /**
       * Email invalid
       */
      emailError: false,
      /**
       * Stripe processing success message
       */
      processingSuccess: "",
      /**
       * Stripe processing error message
       */
      processingError: "",
      /**
       * Styling options for the stripe elements such as typography and color
       */
      stripeOptions: {
        elements: {
          fonts: [
            {
              cssSrc: "https://use.typekit.net/drl7neu.css"
            }
          ]
        },
        style: {
          base: {
            fontSize: "16px",
            fontWeight: 300,
            fontFamily:
              '"proxima-nova","OpenSans","Pridi","NotoSans","NotoSansSC","NotoSansHebrew","NotoSansJapanese","Hiragino Kaku Gothic Pro","Yu Gothic Medium","Yu Gothic",Meiryo,"source-han-sans-japanese","source-han-sans-korean","source-han-sans-simplified-c",Helvetica,Arial,sans-serif'
          },
          invalid: {
            color: "#b2140a"
          }
        }
      },
      /**
       * Used for actual array value of amounts, gets parsed in mounted
       * */
      buttonAmounts: [],
      /**
       * loading message
       */
      loadingMessage: "",
      /**
       * stripe elements ready to load
       */
      stripeElementsReady: false,
      toastOpen: false
    };
  },
  computed: {
    /**
     * Causes donation buttons to break into separate lines at certain lengths
     * */
    donationBtnsStyle: function() {
      let numOfCol = this.buttonAmounts.length;
      if (this.buttonAmounts.length > 8) {
        numOfCol = 5;
      } else if (this.buttonAmounts.length > 5) {
        numOfCol = 4;
      }
      return { gridTemplateColumns: `repeat(${numOfCol}, 1fr)` };
    },
    showCustomAmountError: function() {
      return this.showErrors && this.customAmount != 0 && this.customAmount < 1;
    },
    showEmailError: function() {
      return this.showErrors && this.emailError;
    }
  },
  watch: {
    numberInfo() {
      this.validateFormCompletion();
    },
    expiryInfo() {
      this.validateFormCompletion();
    },
    cvcInfo() {
      this.validateFormCompletion();
    },
    firstName() {
      this.validateFormCompletion();
    },
    lastName() {
      this.validateFormCompletion();
    },
    paymentMethod(value) {
      // reset card info
      if (value !== "card") {
        this.numberInfo = {};
        this.expiryInfo = {};
        this.cvcInfo = {};
      }
      this.validateFormCompletion();
    },
    email() {
      if (this.$refs.emailRef.validity.typeMismatch) {
        this.emailError = true;
      } else {
        this.emailError = false;
      }
      this.validateFormCompletion();
    },
    amount() {
      this.validateFormCompletion();
    },
    customAmount(amt) {
      this.amount = amt || this.buttonAmount;
      if (amt) {
        this.buttonAmount = null;
      }
    },
    processingSuccess(msg) {
      if (msg) {
        this.toastOpen = true;
      } else {
        this.toastOpen = false;
      }
    },
    processingError(msg) {
      if (msg) {
        this.toastOpen = true;
      } else {
        this.toastOpen = false;
      }
    },
    loading(loading) {
      if (!loading) {
        this.loadingMessage = "";
      }
    }
  },
  mounted() {
    // to address iOS bug: stripe elements need to load after mount. See...
    // https://github.com/fromAtoB/vue-stripe-elements/issues/68
    this.stripeElementsReady = true;

    // set inital button amounts
    try {
      this.buttonAmounts = JSON.parse(this.amounts);
    } catch (e) {
      console.warn("Could not parse button amounts from amounts property", e);
    }

    // if there is a search param of 'source' then this page was reached by
    // a redirect from the alipay payment page and we start polling stripe
    // to see if the charge was successful.
    const url = new URL(window.location.href);

    // set inital input values to show what was previously entered
    this.firstName = url.searchParams.get("firstName") || "";
    this.lastName = url.searchParams.get("lastName") || "";
    this.email = url.searchParams.get("email") || "";
    this.affiliateId = url.searchParams.get("affiliateId") || "";
    if (url.searchParams.get("paymentMethod")) {
      this.paymentMethod = url.searchParams.get("paymentMethod");
    }

    const pollIfRedirected = async () => {
      if (
        url.searchParams.get("source") &&
        url.searchParams.get("client_secret")
      ) {
        // Update the interface to display the processing screen.
        this.loading = true;
        this.loadingMessage = this.checkingAlipayText;

        try {
          const { source } = await window
            .Stripe(this.stripeKey)
            .retrieveSource({
              id: url.searchParams.get("source"),
              client_secret: url.searchParams.get("client_secret")
            });

          // Poll the PaymentIntent status.
          this.pollPaymentIntentStatus(source.metadata.paymentIntent);
        } catch (error) {
          this.loading = false;
          console.error("Error with retrieving source from Stripe");
          this.processingError = this.errorMessage;
        }
      }
    };
    pollIfRedirected();
  },
  methods: {
    /**
     * Gets called when a required field is updated
     */
    validateFormCompletion() {
      switch (this.paymentMethod) {
        case "card":
          this.complete =
            this.numberInfo.complete &&
            this.expiryInfo.complete &&
            this.cvcInfo.complete &&
            this.firstName &&
            this.lastName &&
            this.email &&
            this.amount;
          break;
        case "alipay":
          this.complete =
            this.firstName && this.lastName && this.email && this.amount;
          break;
        default:
          this.complete = false;
      }
    },
    /**
     * Gets called when an amount is updated
     */
    updateAmount(amt) {
      this.buttonAmount = amt;
      this.customAmount = 0;
      this.amount = +amt;
    },
    // formats to currency for the Donate button
    formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
      try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";
        amount = Math.abs(Number(amount) || 0).toFixed(decimalCount);
        let i = parseInt(amount).toString();
        let j = i.length > 3 ? i.length % 3 : 0;

        return (
          negativeSign +
          (j ? i.substr(0, j) + thousands : "") +
          i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
          (decimalCount
            ? decimal +
              Math.abs(amount - i)
                .toFixed(decimalCount)
                .slice(2)
            : "")
        );
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * Method that is called once we get the payment token from stripe
     */
    pay() {
      this.processingError = "";
      this.processingSuccess = "";
      if (
        this.emailError ||
        (this.customAmount != 0 && this.customAmount < 1)
      ) {
        this.showErrors = true;
      } else if (this.complete) {
        if (this.amount >= 1) {
          this.loading = true;
          if (this.paymentMethod === "card") {
            this.payWithCard();
          } else if (this.paymentMethod === "alipay") {
            this.payWithAlipay();
          }
        } else {
          // show error if after double checking, amount is still less than $1
          this.processingError = this.minDonationAmountLabel;
        }
      }
    },
    // paying with a card
    async payWithCard() {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(this.captchaKey, {
            action: "submit"
          })
          .then(captcha => {
            createToken()
              .then(
                async response =>
                  await this.createStripeSource(response, captcha)
              )
              .catch(error => {
                this.loading = false;
                console.error(
                  "Error with payment method - createToken: " + error.toString()
                );
                this.processingError = this.errorMessage;
              });
          })
          .catch(err => {
            console.error(err);
          });
      });
    },
    async createStripeSource(response, captcha) {
      if (response.error) {
        this.loading = false;
        console.error("Error with payment method - createToken");
        this.processingError = response.error.message || this.errorMessage;
        return null;
      }

      // turns the token into a source in order to add email to owner
      try {
        const { source } = await window.Stripe(this.stripeKey).createSource({
          type: "card",
          currency: "usd",
          owner: {
            email: this.email
          },
          token: response.token.id
        });
        if (!source) {
          this.loading = false;
          console.error("Error with converting to source - createSource");
          this.processingError = this.errorMessage;
          return null;
        }

        source.captcha = captcha;

        // charge the source
        const { data } = await StripePaymentService.postPaymentTokenToStripe(
          this.amount,
          source.id,
          this.email,
          this.firstName,
          this.lastName,
          this.affiliateId,
          source.captcha
        );
        // show successful page/message
        if (data && data.captured) {
          this.showChargeSuccess();
        } else {
          // charge not captured (not sure if data.messages will ever exist)
          this.processingError = (data && data.messages) || this.errorMessage;
        }
      } catch (error) {
        // charge failed
        const message =
          ((error.response || {}).data || {}).message || error.message;
        this.processingError = message;
      } finally {
        this.loading = false;
      }
    },
    // paying with alipay
    async payWithAlipay() {
      // this will start the alipay process. To confirm success, check 'mounted' function
      // construct return url (using 'set' in case user makes 2nd donation)
      const url = new URL(window.location.href);
      url.searchParams.set("firstName", this.firstName);
      url.searchParams.set("lastName", this.lastName);
      url.searchParams.set("email", this.email);
      url.searchParams.set("affiliateId", this.affiliateId);
      url.searchParams.set("amount", this.amount);
      url.searchParams.set("paymentMethod", "alipay");
      url.searchParams.delete("client_secret");
      url.searchParams.delete("source");

      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(this.captchaKey, {
            action: "submit"
          })
          .then(async captcha => {
            try {
              // create a payment intent and add it to source metadata
              const {
                data: paymentIntent
              } = await StripePaymentService.createPaymentIntent(
                this.amount,
                this.email,
                this.firstName,
                this.lastName,
                this.affiliateId,
                captcha
              );
              // create the source
              const response = await window
                .Stripe(this.stripeKey)
                .createSource({
                  type: "alipay",
                  amount: paymentIntent.amount,
                  currency: paymentIntent.currency,
                  redirect: {
                    return_url: url.href
                  },
                  owner: {
                    email: this.email
                  },
                  metadata: {
                    paymentIntent: paymentIntent.id
                  }
                });
              // navigate to alipay page
              if (response.source && response.source.redirect.url) {
                window.location.assign(response.source.redirect.url);
              } else if (response.error) {
                this.processingError = response.error.message;
              } else {
                this.processingError = this.errorMessage;
              }
              this.loading = false;
            } catch (error) {
              console.log({ error });
              const message =
                ((error.response || {}).data || {}).message || error.message;
              this.loading = false;
              this.processingError = message || this.errorMessage;
            }
          });
      });
    },
    // call after a payment is successful to show success indication
    showChargeSuccess() {
      if (this.thankYouUrl && this.thankYouUrl !== "#") {
        // go to thankyou page
        window.location = this.thankYouUrl;
      } else {
        // With no thankYouUrl -> clear amount, show success message
        this.buttonAmount = null;
        this.customAmount = 0;
        this.amount = 0;
        this.processingSuccess = this.successMessage;
      }
    },
    // for alipay, this will poll stripe to see if charge (paymentIntent.confirm()) was successful
    async pollPaymentIntentStatus(
      paymentIntentId,
      timeout = 15000,
      interval = 500,
      start = Date.now()
    ) {
      const endStates = ["succeeded", "processing", "canceled"];
      // Retrieve the PaymentIntent status from our server.
      const {
        data: paymentIntent
      } = await StripePaymentService.getPaymentIntent(paymentIntentId);
      if (
        !endStates.includes(paymentIntent.status) &&
        Date.now() < start + timeout
      ) {
        // Not done yet. Let's wait and check again.
        setTimeout(
          this.pollPaymentIntentStatus,
          interval,
          paymentIntentId,
          timeout,
          interval,
          start
        );
      } else {
        this.handlePaymentResult(paymentIntent);
        if (!endStates.includes(paymentIntent.status)) {
          // Status has not changed yet. Let's time out.
          console.warn(new Error("Polling timed out."));
          this.processingError =
            "There might be an error. Refresh page to keep checking.";
        }
      }
    },
    handlePaymentResult(paymentIntent) {
      this.loading = false;

      if (paymentIntent.status === "succeeded") {
        // Success! Payment is confirmed. Update the interface to display the confirmation screen.
        this.showChargeSuccess();
      } else if (paymentIntent.status === "processing") {
        this.processingError =
          "Still processing. You may refresh the page to recheck the status.";
      } else {
        // Payment has failed.
        this.processingError = this.errorMessage;
      }
    },
    async getCaptcha() {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(this.captchaKey, {
            action: "submit"
          })
          .then(token => {
            return token;
          })
          .catch(() => {
            return "";
          });
      });
    }
  }
};
